




































import Vue from 'vue';
import Component from 'vue-class-component';

import Button from '@/components/atoms/Button.vue';
import Checkbox from '@/components/atoms/Checkbox.vue';

export class checkedList {
  name: string = '';

  title: string = '';

  value: boolean = false;
}

@Component({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'button-id': Button,
    'checkbox-id': Checkbox,
  },
})
export default class UnsubscribeForm extends Vue {
  arrCheckList: checkedList[] = [
    {
      name: 'TOO_MANY_EMAIL',
      title: 'I received too many email',
      value: false,
    },
    {
      name: 'TOO_FREQUENTLY',
      title: 'I received this email too frequently',
      value: false,
    },
    {
      name: 'ANNOYING',
      title: 'This email is no longer relevant for me',
      value: false,
    },
    {
      name: 'NOT_IMPORTANT',
      title: 'It’s not important for me',
      value: false,
    },
  ];

  public unsubscribeCheck(event: any): void {
    const checked: any = this.arrCheckList.find(check => check.name === event.target.id);
    checked.value = event.target.checked;
  }

  public unsubscribeClick(): void {
    const arrCheckList: checkedList[] = this.arrCheckList.filter(status => status.value);
    const arrSelected: string[] = [];

    arrCheckList.forEach((status) => {
      if (status.value) {
        arrSelected.push(status.name);
      }
    });

    this.$emit('click', arrSelected);
  }
}

